const CardCompletionTypeEnum = {
  timeBased: 'TIME_BASED',
  scrollBased: 'SCROLL_BASED',
  optional: 'OPTIONAL',
  completionFromContent: 'COMPLETION_FROM_CONTENT'
};

export { CardCompletionTypeEnum };
export default CardCompletionTypeEnum;
